export default "__VITE_ASSET__9fbc4eef__"